var _radialGradient, _linearGradient, _linearGradient2, _linearGradient3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIllustrationSceneConfusedColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 271,
    viewBox: "0 0 215 271",
    width: 215,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 107.5,
    cy: 170.83,
    gradientUnits: "userSpaceOnUse",
    r: 103.64
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eaf1fb",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaf1fb"
  }))), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 53.42,
    x2: 81.24,
    y1: 206.52,
    y2: 127.69
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa60d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#ffd500"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 92.46,
    x2: 92.46,
    y1: 192.72,
    y2: 104.19
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#7b4241"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5e2a2a"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 111.16,
    x2: 111.16,
    y1: 40.51,
    y2: -2.84
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cde1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9f3ff"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2 204.52c2.7 10.15 8.63 19.43 17.13 25.26a44.62 44.62 0 0 0 20.27 7.59c1.44.16 2.89.25 4.33.27 12.47.17 24.12 5.77 33 14.5a65.69 65.69 0 0 0 8.74 7.19 66.52 66.52 0 0 0 8.55 5 65.08 65.08 0 0 0 42.1 5.11 66 66 0 0 0 42.88-30.44 65.37 65.37 0 0 0 9.18-29.13 55.78 55.78 0 0 1 6.54-22.56 58.21 58.21 0 0 1 8.28-11.63 44.72 44.72 0 0 0 7.37-10.93 44.65 44.65 0 0 0 -14.64-55.59 55.51 55.51 0 0 0 -13.2-6.39c-13.12-4.76-25.21-11.93-36.62-20a67.06 67.06 0 0 0 -7.91-4.77 65.83 65.83 0 0 0 -84.86 22.32 67.57 67.57 0 0 0 -4.87 8.82 65.57 65.57 0 0 0 -4.18 12.27 56.76 56.76 0 0 1 -23.73 34.26 45.72 45.72 0 0 0 -15.7 17.45c-4.79 9.51-5.43 20.88-2.66 31.4z",
    fill: "url(#a)",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m161.15 246.91-5.45-6.28 3.29-4.3s5.65 2.36 9.37-.59a21 21 0 0 1 6.86-3.78l-4.3 9.93z",
    fill: "#7b4241"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m124 114c-.37-2.17 0-7.91 4-14.08 3.55-5.41 1.83-9.54 1.67-11-.26-8.1-9.91-4.57-17.77-8.28-11.15-5.27-16-11.9-21.25-.81-5 10.53-13.13 22.83-4.42 28.56-.92 2.53-5.12 12.75-14 16.07-9.75 3.65 18 29.29 18.93 12.51a31.48 31.48 0 0 1 7.42-18.36c11.62 10.07 15.34 6.26 15.34 6.26l1.09-1.41a1.72 1.72 0 0 0 .49.34 2 2 0 0 0 2.58-1 2 2 0 0 0 .05-1.36 1.93 1.93 0 0 0 1.15-3.52l.93-1.21s4.35.81 3.79-2.71z",
    fill: "#7b4241"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m43.52 181.6c-.45 10.67 5.16 29.07 5.16 29.07l20.16.29s2.65-34.73 16.52-45.14c19.28-14.47 7.1-20.63 9.54-39.64l-17.18-5s-32 7.75-34.2 60.42z",
    fill: "url(#b)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m155.2 241.19 6.43-4.85c-17.61-21.09-22.51-24.1-43.5-39.72-19.2-14.29-39.91 7.23-48.91 10.71l-20.22 3.25s-18.62 22.91 5.34 28.21c13.88 3.07 25.23-4.46 45.79-22.07 11.01-9.39 33.62 5.36 55.07 24.47z",
    fill: "#1a1e5a"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m160 246.81s.46 3.89 5.56 7.33l18.47-24.52s1.59-9.94-10.3 2.87c.03 0 1.44 7.21-13.73 14.32z",
    fill: "#ffd500"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m129.31 96.59a4.41 4.41 0 0 0 7.43-.89 4.34 4.34 0 0 0 .4-2 4.41 4.41 0 0 0 4.66-7.13 4.41 4.41 0 0 0 1.68-8.41 4.36 4.36 0 0 0 -2-.4v-.19a4.42 4.42 0 1 0 -3.8-7.89l-.15-.19-.31-.33a4.38 4.38 0 0 0 .94-1.29 4.41 4.41 0 0 0 -6.82-5.28 4.41 4.41 0 0 0 -7.3-4.74 4.41 4.41 0 0 0 -7.83-3.49 4.4 4.4 0 0 0 -8.08-1.92 4.4 4.4 0 0 0 -8-.16 4.16 4.16 0 0 0 -1.24-.9 4.43 4.43 0 0 0 -5.89 2.13c0 .11-.07.22-.11.33a4.42 4.42 0 0 0 -5.32 2.32 4.35 4.35 0 0 0 -.39 2.23 4.41 4.41 0 0 0 -5 6.36 4.4 4.4 0 0 0 -4.46 7.34 4.41 4.41 0 0 0 -3.9 7.78 4.41 4.41 0 0 0 -2.06 8.37 4.42 4.42 0 0 0 -.28 8.12 4.51 4.51 0 0 0 1.59.41 4.24 4.24 0 0 0 -1 1.35 4.41 4.41 0 0 0 6.71 5.36l.4.4a4.71 4.71 0 0 0 -.62 1 4.42 4.42 0 0 0 8 3.78 4.48 4.48 0 0 0 .33-1 15.87 15.87 0 0 0 -.07-5.28c-.34-2.53-1-6.52 1-10s6.47-2.54 7.49 1.7c1.1 4.52 4.16 5.55 8.92.73s11-9.12 25.08 1.78z",
    fill: "#1a1e5a"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m106.05 104.29c-1.92-.73-3.07 2.77-4.51 6-1.18 2.63-1.27 2.92-2.33 5.57a10.39 10.39 0 0 0 .37 8.59c1.8 3.5 1.39 5.28 1.39 5.28l-2.13 43.8c-4.4-10-5.35-12.7-10-23-3.7-1.73-7.54-3.69-11.16-5.23-6.54 1.65-3.75 11.27-2.7 14.48 3 9.14 13.15 24 17.37 28.07 5.55 5.3 11 7.69 14.32-.19 4.81-11.37 2.4-46.43.76-55.91.44-8.49 2.25-6.08 3.08-10.74-.02-.01 4.03-13.54-4.46-16.72z",
    fill: "url(#c)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m91.72 156.11-15.91 5.63a2.47 2.47 0 0 1 -2.94-1.8l-5.31-15c-2.4-6.79.13-13.93 5.63-15.88 5.5-1.94 12 2 14.37 8.81l5.31 15a2.47 2.47 0 0 1 -1.15 3.24z",
    fill: "#ffd500"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m106.41.16a13.84 13.84 0 0 1 8.29 7.42 13.5 13.5 0 0 1 1.19 6.05 16 16 0 0 1 -.38 3 23.91 23.91 0 0 1 -.7 2.71c-.53 1.76-1.22 3.38-1.8 4.87a19.92 19.92 0 0 0 -1.3 4.14 10.33 10.33 0 0 0 .24 4.27 44 44 0 0 0 1.64 4.9 13.89 13.89 0 0 1 -2.31-1.52 13.1 13.1 0 0 1 -2-2 10.67 10.67 0 0 1 -2.35-5.63 16 16 0 0 1 .63-6c.5-1.78 1.07-3.37 1.56-4.89.26-.77.48-1.53.7-2.27.11-.36.22-.77.29-1.1a9 9 0 0 0 .22-1 12 12 0 0 0 0-4.14 22.5 22.5 0 0 0 -3.92-8.81z",
    fill: "url(#d)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationSceneConfusedColor);
export default __webpack_public_path__ + "static/media/illustration-scene-confused-color.6f80b0f0cca947736d2f1b315e0fc567.svg";
export { ForwardRef as ReactComponent };